import { Component } from "react"
import PropTypes from "prop-types"
import ClickOutside from "react-click-outside"
import classnames from "classnames"

import colors from "foundation/_colors_export.scss?variables"

import {
  ServiceListElement,
  orgShape,
  serviceShape,
} from "./selector_components"

export default class ServiceSelectMenu extends Component {
  state = {
    open: false,
  }

  toggleOpen = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ open: !this.state.open })
  }

  onClickOutside = () => {
    this.setState({
      open: false,
    })
  }

  renderServiceMenuItems() {
    const { activeOrg, currentService } = this.props

    const serviceHasAnOrg = activeOrg.services.some(
      s => s.module_name === currentService.module_name
    )
    const menuServices = serviceHasAnOrg ? activeOrg.services : [currentService]

    if (this.state.open) {
      return [
        ...menuServices.map((service, index) => (
          <ServiceListElement
            key={index}
            service={service}
            shouldRenderChevron={serviceHasAnOrg && index === 0}
            menuIsOpen={this.state.open}
            toggleOpen={this.toggleOpen}
            handleMenuClick={this.handleServiceMenuItemClick}
          />
        )),
        serviceHasAnOrg && (
          <li className="add-item" key={activeOrg.services.length}>
            <a
              onClick={e => {
                e.preventDefault()
                // Are they holding command and wanting to open this in a new tab? Let 'em.
                if (e.metaKey) {
                  return window.open(e.target.href, "_blank")
                }
                window.Turbolinks.visit(e.target.href)
              }}
              href={`/services/new?org_id=${this.props.activeOrg.id}`}
              title={`Add a new Service to the ${this.props.activeOrg.name} Organization`}
            >
              + Add Service
            </a>
          </li>
        ),
      ]
    } else if (currentService && currentService.organization) {
      return (
        <ServiceListElement
          service={currentService}
          shouldRenderChevron
          isMakerService={false}
          menuIsOpen={this.state.open}
          toggleOpen={this.toggleOpen}
          handleMenuClick={this.handleServiceMenuItemClick}
        />
      )
    }
  }

  handleServiceMenuItemClick = service => {
    if (this.state.open) {
      if (
        this.props.currentService.name === service.name &&
        window.location.pathname.includes(`/services/${service.module_name}`)
      ) {
        return this.setState({ open: false })
      }
      return window.Turbolinks.visit(service.url)
    }
    this.setState({ open: true })
  }

  getColor(org) {
    if (org.color_hsl === "#000") {
      return colors.primaryTextColor
    }
    return org.color_hsl
  }

  render() {
    let navClass = classnames("service-dropdown", {
      "services-open": this.state.open,
    })
    return (
      <ClickOutside onClickOutside={this.onClickOutside}>
        <nav className={navClass}>
          <ul
            className="service-list"
            style={{ backgroundColor: this.getColor(this.props.activeOrg) }}
          >
            {this.renderServiceMenuItems()}
          </ul>
        </nav>
      </ClickOutside>
    )
  }
}

ServiceSelectMenu.propTypes = {
  activeOrg: orgShape,
  currentService: serviceShape,
  currentOrganization: orgShape,
  otherId: PropTypes.number,
  baseURI: PropTypes.string,
  makerURI: PropTypes.string,
}
